import { Project } from 'src/modules/common/types/Project';
import { createParameterSelector } from 'src/utils/selectorUtils';

export const getProjectLazy = createParameterSelector<Project>();
